import React, { useState } from 'react'
import { t } from 'i18next'
import { useHistory } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close'
import Navigation from 'Components/Navigation'
import MiniLoading from 'Components/MiniLoading'
import { SERVICE_REQUEST_FORM_URL } from 'Utils/constants'
import './installationService.css'

export default function InstallationService() {
  const history = useHistory()
  const [iframeLoaded, setIframeLoaded] = useState(false)

  const isPageLoading = !iframeLoaded

  return (
    <>
      <Navigation />
      <div className="installation_service_request">
        <div className="installation_service_request_header">
          <h1 className="installation_service_request_title">
            {t('INSTALLATION_SERVICE_T.TITLE')}
          </h1>
          <div className="close-icon-wrapper">
            <CloseIcon fontSize="inherit" onClick={() => history.goBack()} />
          </div>
        </div>

        {isPageLoading && <MiniLoading full={true} noMargin={true} />}

        <div
          className="iframe-tracking-container"
          style={{ display: iframeLoaded ? 'block' : 'none' }}>
          <iframe
            src={SERVICE_REQUEST_FORM_URL}
            className="iframe-tracking-element"
            title="Installation Service Request"
            sandbox="allow-same-origin allow-scripts allow-forms"
            onLoad={() => setIframeLoaded(true)}
          />
        </div>
      </div>
    </>
  )
}
